import React, { lazy, useEffect, useRef } from 'react'
import { useFeatureFlagVariantKey } from '@posthog/react'
import posthog from 'posthog-js'
import Sherpa, { TYPE_LARGE } from '../Sherpa/index'
import { POSTHOG_FEATURE_FLAGS } from '../PostHog/index'

const LoadableSearch = lazy(
  () => import('../SearchPage/index'),
  { fallback: <Sherpa type={TYPE_LARGE} /> },
)

export default function SearchPageSwitch (props) {
  const aiSearchVariant = useFeatureFlagVariantKey(
    POSTHOG_FEATURE_FLAGS.AI_SEARCH_WEB,
  )

  // Track experiment exposure for the AI Search A/B test.
  // Both test and control users render the same SearchPage — the PostHog
  // flag gates the AI overview visibility inside the component.
  // Fire exactly once per mount: experiment_exposure is a custom event and is
  // NOT deduplicated by PostHog (only $feature_flag_called is, and we drop that
  // server-side), so without this latch every Search remount re-emits and
  // inflates the ai-search-web experiment denominator. Mirrors DailyDivinationCard.
  const exposureFiredRef = useRef(false)
  useEffect(() => {
    if (exposureFiredRef.current) return
    if (aiSearchVariant === 'test' || aiSearchVariant === 'control') {
      exposureFiredRef.current = true
      posthog.capture('experiment_exposure', {
        '$feature/ai-search-web': aiSearchVariant,
        experiment: 'ai-search-web',
      })
    }
  }, [aiSearchVariant])

  return <LoadableSearch location={props.location} history={props.history} />
}
